import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appDateMask]' // Seu seletor custom
})
export class DateMaskDirective {

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: InputEvent) {
    const input = this.el.nativeElement as HTMLInputElement;
    let value = input.value;

    // Remove tudo que não for dígito
    value = value.replace(/\D/g, '');

    // Máximo de 8 dígitos: DDMMYYYY
    if (value.length > 8) {
      value = value.substring(0, 8);
    }

    // Monta com /: DD/MM/YYYY
    if (value.length >= 5) {
      value = value.replace(/(\d{2})(\d{2})(\d{1,4})/, '$1/$2/$3');
    } else if (value.length >= 3) {
      value = value.replace(/(\d{2})(\d{1,2})/, '$1/$2');
    }

    input.value = value;
  }

  // Opcional: bloquear caracteres não numéricos no keypress
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const allowed = /[0-9]/;
    if (!allowed.test(event.key)) {
      event.preventDefault();
    }
  }

}